import { render, staticRenderFns } from "./FlutterView.vue?vue&type=template&id=46215763"
import script from "./FlutterView.vue?vue&type=script&lang=js"
export * from "./FlutterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports